import { auth } from "./firebaseConfig";
import { formatDateToYYYYMMDD } from "utils/dateUtils";

const SCRIPT_URL_BASE =
  "https://script.google.com/macros/s/AKfycbz6q9fVn-7P-C8xp70wJeT7_M1DaGg1imtxBhtKiqAm1NzHTDK8z7Z71WiQwLYY45_Tlw/exec";

export const fetchExcursions = async (date, signal) => {
  const user = auth.currentUser;
  if (!user) throw new Error("Usuário não autenticado.");

  const dateStr = formatDateToYYYYMMDD(date);

  const url = `${SCRIPT_URL_BASE}?date=${dateStr}&type=excursions&userEmail=${user.email}`;

  const response = await fetch(url, { signal });
  if (!response.ok) throw new Error(`Failed to fetch`);
  const data = await response.json();
  if (data.error) throw new Error(data.error);
  return data;
};

export const fetchChales = async (date, signal) => {
  const user = auth.currentUser;
  if (!user) throw new Error("Usuário não autenticado.");

  const dateStr = formatDateToYYYYMMDD(date);
  const url = `${SCRIPT_URL_BASE}?date=${dateStr}&type=chales&userEmail=${user.email}`;

  const response = await fetch(url, { signal });
  if (!response.ok) throw new Error(`Failed to fetch`);
  const data = await response.json();
  if (data.error) throw new Error(data.error);
  return data;
};

export const launchChalesFinancials = async (payload) => {
  const user = auth.currentUser;

  if (!user) throw new Error("Usuário não autenticado.");

  const options = {
    method: "POST",
    headers: { "Content-Type": "text/plain;charset=utf-8" },
    body: JSON.stringify({
      action: "launchFinancials",
      userEmail: user.email,
      payload: payload,
    }),
    mode: "cors",
  };

  const response = await fetch(SCRIPT_URL_BASE, options);
  const result = await response.json();
  if (result.error) throw new Error(result.error);
  return result;
};

export const addManualExcursion = async (payload) => {
  const user = auth.currentUser;
  if (!user) throw new Error("Usuário não autenticado.");

  const options = {
    method: "POST",
    headers: { "Content-Type": "text/plain;charset=utf-8" },
    body: JSON.stringify({
      action: "addExcursion",
      userEmail: user.email,
      payload: payload,
    }),
    mode: "cors",
  };

  const response = await fetch(SCRIPT_URL_BASE, options);
  const result = await response.json();
  if (result.error) throw new Error(result.error);
  return result;
};
